<template>
    <div class="network_error">
        <div class="img">
            <img src="../../assets/img/error/network_error.png" alt="">
        </div>
        <div class="tips">网络出错啦，请点击按钮重新加载</div>
        <div class="load" @click="reload">重新加载</div>
    </div>
</template>
<script>
export default {
  name: "network_error",
  data() {
    return {
     
    };
  },
  created() {
    
  },
  mounted() {},
  methods: {
      reload(){
          this.$router.go(-1);
      }
   
  
  }
};
</script>
<style lang="less" scoped>
.network_error{
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top:4.4rem;
    .img{
        width: 1.13rem;
        height: 1.39rem;
        margin-bottom: 0.4rem;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .tips{
        color: #999999;
        font-size: 0.24rem;
        margin-bottom: 0.5rem;
    }
    .load{
        padding: 0.16rem 1rem;
        border:0.01rem solid #CCCCCC;
        border-radius:0.3rem;
        color: #666666;
        font-size: 0.3rem;


    }
}

</style>